import { CourseCompletionConfig } from "./model";

declare const __ORIGIN_CONFIG__: CourseCompletionConfig;

export const getConfig = (): CourseCompletionConfig => {
  return __ORIGIN_CONFIG__;
};
